import { ESTADO_REVISION_PROPERTIES } from "common/utils/constants"
import { useTranslation } from "react-i18next"
import "./styles.scss"

const DocumentosEstadoMessage = () => {
  const { t } = useTranslation()
  return (
    <div className='pb-2'>
      <p className='estado-title'>
        <span className='ml-2'>
          {t("crear.presupuesto.tab.statusMessageTitle")}
        </span>
      </p>

      {Object.values(ESTADO_REVISION_PROPERTIES(t)).map(
        ({ color, text, description }) => (
          <div
            key={color}
            className='content-estado'
          >
            <div className='estado-meta'>
              <span style={{ color }}>{text}</span>
              <span>{description}</span>
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default DocumentosEstadoMessage
